import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Urbanist from "@fontsource/urbanist";
import HeaderMenu from "components/HeaderMenu/HeaderMenu";
import UserAccount from "components/UserAccount/UserAccount";

const drawerWidth = 82.5;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: `calc(100% - ${drawerWidth}px)`
    
}));

const defaultTheme = createTheme();

export default function HeaderLayout() {
    return (
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <AppBar position="fixed">
                <Toolbar sx={{ backgroundColor: 'white', color: '#3299FF', }} >
                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        fontFamily={Urbanist}
                        fontWeight="700"
                        fontSize="2.5rem"
                        lineHeight="1.5"
                        letterSpacing="0.05em"
                        noWrap sx={{ flexGrow: 1 }}>
                        ASTT
                    </Typography>
                    <IconButton color="inherit">
                        <HeaderMenu />
                    </IconButton>
                    <IconButton color="inherit">
                        <UserAccount />
                    </IconButton>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    );
}